import {FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, useTheme} from "@mui/material";
import {Control, Controller, FieldValues, Path, useFormContext} from "react-hook-form";

type RadioButton = {
    value: string | number,
    label: string
}

type RadioButtonProps<IFormValues extends FieldValues = FieldValues, T extends any = any, DisableClearable extends (boolean | undefined) = undefined, FreeSolo extends (boolean | undefined) = undefined> = {
    label: string
    control?: Control<IFormValues, any>,
    name: Path<IFormValues>,
    readOnly?: boolean,
    radioButtons: RadioButton[],
    handleChange?: Function,
}

const FormRadioGroupWithOnChange = <IFormValues extends FieldValues = FieldValues, T extends any = any, DisableClearable extends (boolean | undefined) = undefined, FreeSolo extends (boolean | undefined) = undefined>(
    {
        name,
        control,
        label,
        readOnly = false,
        radioButtons,
        handleChange
    }: RadioButtonProps<any, T, DisableClearable, FreeSolo>) => {

    // Use Theme
    const theme = useTheme();

    // Use Form Context
    const formContext = useFormContext<IFormValues>();

    return (
        <Controller
            name={name}
            control={control ?? formContext.control}
            render={({field, fieldState}) =>
                <FormControl error={!!fieldState.error} sx={{width: "100%"}}>
                    <FormLabel>{label}</FormLabel>
                    <RadioGroup
                        row
                        name={name}
                        value={field.value}
                        onChange={(e, value) => {
                            handleChange ? handleChange(value) : field.onChange(value);
                        }}
                        color={"accent"}
                    >
                        {radioButtons.map(rb => (
                            <FormControlLabel
                                key={rb.value}
                                value={rb.value}
                                label={rb.label}
                                sx={{margin: 0}}
                                control={<Radio
                                    sx={{
                                        color: theme.palette.accent.main,
                                        "&.Mui-checked": {
                                            color: theme.palette.accent.main
                                        }
                                    }}
                                />}
                                disabled={readOnly}
                            />
                        ))}
                    </RadioGroup>
                </FormControl>
            }
        />
    );
};

export default FormRadioGroupWithOnChange;
